/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Subscribed_Success_TitleInputs */

const en_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You’ve unlocked 
Forest Plus!`)
};

const ar_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد قمت بفتح
Forest بلس!`)
};

const de_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast Forest Plus freigeschaltet!`)
};

const es_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Has desbloqueado 
Forest Plus!`)
};

const fr_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez débloqué
Forest Plus !`)
};

const it_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai sbloccato 
Forest Plus!`)
};

const ja_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plusが
アンロックされました`)
};

const ko_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus가
개방되었어요!`)
};

const pt_br_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você desbloqueou
o Forest Plus!`)
};

const ru_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы разблокировали 
Forest Plus!`)
};

const th_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณได้ปลดล็อก
Forest Plus แล้ว!`)
};

const tr_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus'ın kilidini açtın!`)
};

const zh_cn_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成功升级为 
Forest Plus!`)
};

const zh_tw_onboarding_paywall_subscribed_success_title = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成功升級為 
Forest Plus!`)
};

/**
* | output |
* | --- |
* | "You’ve unlocked Forest Plus!" |
*
* @param {Onboarding_Paywall_Subscribed_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_subscribed_success_title = /** @type {((inputs?: Onboarding_Paywall_Subscribed_Success_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Subscribed_Success_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_subscribed_success_title(inputs)
	if (locale === "ar") return ar_onboarding_paywall_subscribed_success_title(inputs)
	if (locale === "de") return de_onboarding_paywall_subscribed_success_title(inputs)
	if (locale === "es") return es_onboarding_paywall_subscribed_success_title(inputs)
	if (locale === "fr") return fr_onboarding_paywall_subscribed_success_title(inputs)
	if (locale === "it") return it_onboarding_paywall_subscribed_success_title(inputs)
	if (locale === "ja") return ja_onboarding_paywall_subscribed_success_title(inputs)
	if (locale === "ko") return ko_onboarding_paywall_subscribed_success_title(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_subscribed_success_title(inputs)
	if (locale === "ru") return ru_onboarding_paywall_subscribed_success_title(inputs)
	if (locale === "th") return th_onboarding_paywall_subscribed_success_title(inputs)
	if (locale === "tr") return tr_onboarding_paywall_subscribed_success_title(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_subscribed_success_title(inputs)
	return zh_tw_onboarding_paywall_subscribed_success_title(inputs)
});